import { render, staticRenderFns } from "./MaterialSymbolsCheck.vue?vue&type=template&id=a453983c&"
import script from "./MaterialSymbolsCheck.vue?vue&type=script&lang=ts&"
export * from "./MaterialSymbolsCheck.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports